var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewFavourited(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "31px",
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewFavourited") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4283962,11.3415 C24.9198962,10.8625 25.0933962,10.1595 24.8813962,9.506 C24.6688962,8.8525 24.1153962,8.386 23.4353962,8.287 L17.3893962,7.4085 C17.1318962,7.371 16.9093962,7.2095 16.7943962,6.976 L14.0913962,1.498 C13.7878962,0.8825 13.1718962,0.5 12.4853962,0.5 C11.7993962,0.5 11.1833962,0.8825 10.8798962,1.498 L8.17639624,6.9765 C8.06139624,7.21 7.83839624,7.3715 7.58089624,7.409 L1.53489624,8.2875 C0.855396239,8.386 0.301396239,8.853 0.0888962393,9.5065 C-0.123103761,10.16 0.0503962393,10.863 0.541896239,11.342 L4.91639624,15.606 C5.10289624,15.788 5.18839624,16.05 5.14439624,16.306 L4.11239624,22.327 C4.02089624,22.857 4.15989624,23.3725 4.50289624,23.779 C5.03589624,24.4125 5.96639624,24.6055 6.71039624,24.2145 L12.1173962,21.3715 C12.3433962,21.253 12.6278962,21.254 12.8533962,21.3715 L18.2608962,24.2145 C18.5238962,24.353 18.8043962,24.423 19.0938962,24.423 C19.6223962,24.423 20.1233962,24.188 20.4678962,23.779 C20.8113962,23.3725 20.9498962,22.856 20.8583962,22.327 L19.8258962,16.306 C19.7818962,16.0495 19.8673962,15.788 20.0538962,15.606 L24.4283962,11.3415 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-24.0%",
    y: "-25.1%",
    width: "148.1%",
    height: "150.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.4283962,11.3415 L20.0538962,15.606 C19.8673962,15.788 19.7818962,16.0495 19.8258962,16.306 L20.8583962,22.327 C20.9498962,22.856 20.8113962,23.3725 20.4678962,23.779 C20.1233962,24.188 19.6223962,24.423 19.0938962,24.423 C18.8043962,24.423 18.5238962,24.353 18.2608962,24.2145 L12.8533962,21.3715 C12.6278962,21.254 12.3433962,21.253 12.1173962,21.3715 L6.71039624,24.2145 C5.96639624,24.6055 5.03589624,24.4125 4.50289624,23.779 C4.15989624,23.3725 4.02089624,22.857 4.11239624,22.327 L5.14439624,16.306 C5.18839624,16.05 5.10289624,15.788 4.91639624,15.606 L0.541896239,11.342 C0.0503962393,10.863 -0.123103761,10.16 0.0888962393,9.5065 C0.301396239,8.853 0.855396239,8.386 1.53489624,8.2875 L7.58089624,7.409 C7.83839624,7.3715 8.06139624,7.21 8.17639624,6.9765 L10.8798962,1.498 C11.1833962,0.8825 11.7993962,0.5 12.4853962,0.5 C13.1718962,0.5 13.7878962,0.8825 14.0913962,1.498 L16.7943962,6.976 C16.9093962,7.2095 17.1318962,7.371 17.3893962,7.4085 L23.4353962,8.287 C24.1153962,8.386 24.6688962,8.8525 24.8813962,9.506 C25.0933962,10.1595 24.9198962,10.8625 24.4283962,11.3415 Z M23.0068359,11.9461263 C23.6738281,11.351888 24.4036865,10.6966553 24.2591553,9.83794992 C24.114624,8.97924457 22.9876384,8.84357561 22.3839111,8.75568003 L16.8393071,7.97527376 C16.6106898,7.94197998 16.4131467,7.79859475 16.3110458,7.59128547 L13.9112299,2.72772969 C13.6417723,2.18126774 13.4733276,1.28668213 12.5,1.28668213 C11.5266724,1.28668213 11.3294081,2.18126774 11.0599504,2.72772969 L8.65969061,7.59172938 C8.55758967,7.79903867 8.35960265,7.94242389 8.13098534,7.97571768 L2.76313973,8.75568003 C1.57455444,8.82443237 0.713623047,9.16558838 0.713623047,10.0270386 C0.713623047,10.8884888 2.13777669,11.7961629 2.24723307,11.9461263 L5.7653511,15.2532947 C5.93093218,15.4148805 6.006842,15.647493 5.9677773,15.8747786 L5.0515324,21.2204284 C4.96952311,21.6417236 4.50805664,22.8962154 5.0515324,23.2756076 C5.9197339,23.881686 6.69757701,23.2433586 7.35812566,22.8962154 L12.1586452,20.3721028 C12.3592957,20.2668944 12.6118846,20.2677823 12.8120912,20.3721028 L17.1962891,22.7044271 C17.4297895,22.8273921 19.0947266,23.9679339 19.8041992,23.4320747 C20.5136719,22.8962154 20.1347656,22.2316895 19.919204,21.2204284 L19.0025152,15.8747786 C18.9634505,15.6470491 19.0393603,15.4148805 19.2049414,15.2532947 L23.0068359,11.9461263 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Likes-Swipe-Copy-2",
    transform: "translate(-30.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icViewFavourited",
    transform: "translate(34.000000, 639.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#10C2E1",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewFavourited);
export default __webpack_public_path__ + "static/media/icViewFavourited.b0c79cb7738247f0faaa64892807cd86.svg";
export { ForwardRef as ReactComponent };